import { useState } from 'react';
import { useAuthStore } from '@/shared/stores/auth-store';
import { setSessionToken } from '@/shared/services/session-token';
import { AppButton } from '@/shared/components/ui/AppButton';
import { fetchSession } from '@/features/auth/api/auth-api';
import styles from './EmbeddedAuthGate.module.scss';

/**
 * Shown when Promote is embedded but the shared Events.com session cookie could
 * not be verified (AuthBootstrap already attempted it). Offers a retry rather
 * than redirecting the host away to Promote's own login.
 */
export function EmbeddedAuthGate() {
  const setSession = useAuthStore((s) => s.setSession);
  const [retrying, setRetrying] = useState(false);

  async function retry() {
    setRetrying(true);
    try {
      const session = await fetchSession();
      setSessionToken(session.token);
      setSession({
        user: session.user,
        permissions: session.permissions,
        orgId: session.selectedOrganizationId,
        organizations: session.organizations,
      });
    } catch {
      // Stay on the gate; the button re-enables below.
    } finally {
      // Always re-enable, even if the session resolved but is still unauthenticated.
      setRetrying(false);
    }
  }

  return (
    <div className={styles.gate}>
      <p>We couldn’t verify your Events.com session for Promote.</p>
      <AppButton onClick={() => void retry()} disabled={retrying}>
        {retrying ? 'Retrying…' : 'Retry'}
      </AppButton>
    </div>
  );
}
